import Paper from '@mui/material/Paper';
import React from 'react';
import { connect } from 'react-redux';

import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import { fetchAllTamperIssue } from '@sophocles/views/admin/engineering/tamperIssue/TamperIssueActions';
import TamperIssueList from '@sophocles/views/admin/engineering/tamperIssue/TamperIssueList';

class TamperIssuePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  _setLoading = loading => this.setState({ loading });

  render() {
    const { customer } = this.props;
    const { loading } = this.state;
    const pageTitle = 'Structures With Enclosure Issue';
    return (
      <AppNav {...this.props} loading={loading} page="admin_home" notFullHeight={true}>
        <div className="container-fluid" style={{ top: '64px', height: '100%', margin: '0 var(--page-px)' }}>
          <TitleBar showBackButton title={pageTitle} />
          <div className="row">
            <Paper
              sx={{
                width: '100%',
                bgcolor: 'background.paper',
                mb: 'var(--space-4)',
                p: 'var(--space-4)',
              }}
            >
              <TamperIssueList {...this.props} setLoading={this._setLoading} />
            </Paper>
          </div>
        </div>
      </AppNav>
    );
  }
}

function mapStateToProps(state) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {
    fetchTamperIssue: tableParams => dispatch(fetchAllTamperIssue(tableParams)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(TamperIssuePage);
